export function convert_to_request_parameters(range, startTime, endTime) {
  // Convert to Date objects if they are strings
  let startDate = range.startDate;
  let endDate = range.endDate;
  let startTimeObj = startTime;
  let endTimeObj = endTime;

  if (typeof startDate === "string") {
    startDate = new Date(startDate);
  }
  if (typeof endDate === "string") {
    endDate = new Date(endDate);
  }
  if (typeof startTimeObj === "string") {
    startTimeObj = new Date(startTimeObj);
  }
  if (typeof endTimeObj === "string") {
    endTimeObj = new Date(endTimeObj);
  }

  let start_date =
    startDate && startDate.getFullYear
      ? startDate.getFullYear() +
        "-" +
        (startDate.getMonth() + 1) +
        "-" +
        startDate.getDate()
      : "";

  let start_ts =
    start_date === ""
      ? ""
      : "T" +
        startTimeObj.getHours() +
        "%3A" +
        startTimeObj.getMinutes() +
        "%3A" +
        startTimeObj.getSeconds();

  let end_date =
    endDate && endDate.getFullYear
      ? endDate.getFullYear() +
        "-" +
        (endDate.getMonth() + 1) +
        "-" +
        endDate.getDate()
      : "";

  let end_ts =
    end_date === ""
      ? ""
      : "T" +
        endTimeObj.getHours() +
        "%3A" +
        endTimeObj.getMinutes() +
        "%3A" +
        endTimeObj.getSeconds();

  let result = {
    start: start_date + start_ts,
    end: end_date + end_ts,
  };
  return result;
}
